import core from '../../../js/core/core'

import * as types from '../mutation-types'
import EventBus from '@/vue/events/event-bus'
import vueCookie from 'vue-cookie'

// initial state
const state = {
  market: {
    inPlayMarket: {
      key: '3',
      lang: window.lang.home['HOME.WELCOME_IN_PLAY'], 
      betLang: window.lang.home['HOME.BET_IN_PLAY'],
    },
    tdyMarket: {
      key: '1',
      lang: window.lang.home['HOME.WELCOME_TODAYS_MARKET'],
      // betLang: window._lang.betTdyMarket,
      betLang: window.lang.home['HOME.BET_TODAYS_MARKET'],
    },
    earlyMarket: {
      key: '2',
      lang: window.lang.home['HOME.WELCOME_EARLY_MARKET'],
      // betLang: window._lang.betEarlyMarket,
      betLang: window.lang.home['HOME.BET_EARLY_MARKET'],
    },
    scheduleMarket: {
      key: '7',
      lang: window.lang.home['HOME.BUTTON_SCHEDULE'],
      // betLang: window._lang.betEarlyMarket,
      // betLang: window.lang.home['HOME.BET_EARLY_MARKET'],
    },
  },
  sortTypes: {
    time: {
      key: '2',
      lang: 'SPORT_TABLE.SUBHEADER_SORTBY_TIME',
    },
    competition: {
      key: '1',
      lang: 'SPORT_TABLE.SUBHEADER_SORTBY_COMPETITION',
    },
  },
  sportBettypeList: null,
  arr_sportList:{},
  arr_sportAll:{},
  int_selectedMarket: null,
  arr_leagueList:[],
  arr_selectedLeague:null,
  sportTableLang: window._lang.sportTableLang,
  arr_earlyParlayDateList: null,
  int_selectedParlayDate:99,
  arr_selectedEvent: null,
  oddTypesList: window.odds,
  allSportLang: window._lang.allSportLang,
  allBettypeLang: window._lang.allBettypeLang,
  allPlaytypeLang: window._lang.allPlaytypeLang,
  arr_selectedLeagues: [],
  arr_leagues: [],
  showCalendarBox: false,
  selectedMatches: false,
  isParlay: false,
  isSpecial: false,
  isVip: false,
  isPlaceBet: false,
  isProcessBet: false,
  totalPage: 1,
  selectedPage: 1,
  s_odd: false,
  selectedMarket: '1',
  isGameBannerSelected: false,
  isCorrectScore: false,
  parlaySportList:{},
  sportSelected: false,
  arr_sportCountMarket:{},
  isOtr: false,
  isResult: false,
  arr_earlyEventCountByDate:{},
  todayRBLeagueList: {},
  arr_filterLeagueList: {},
  arr_sortedLeagueList: {},
  selectedChar: null,
  arr_selectedLeagueList: [],
  selectedLeagues: 0,
  totalLeagues: 0,
  sportList: [],
  reloadSportTable: false,
  changeOdds: [],
  swipe: 1,
  isCollapseMatch: [],
  showEnd: false,
  allowLanscape: false,
  showNoScrollEnd: false,
  isHideLeague: [],
  defaultSport: 'N1',
  gameBannerId: null,
  gameBannerSportId: null,
  schedule_sprt: 'N1',
  isresult_schedule: false,
  filter_select_all: true,
  market_button_toggle: false, // declare if button above (eg. today/early button) has clicked
  subMenuStatus: {},
  sc_cs_hide: {},
  selected_date: null,
  selected_timezone: '7',
  selected_league: null,
  selected_country: null,
}

// getters
const getters = {
  market: state => state.market,
  arr_sportList: state => state.arr_sportList,
  arr_sportAll: state => state.arr_sportAll,
  int_selectedMarket: state => state.int_selectedMarket,
  sportBettypeList: state => state.sportBettypeList,
  arr_leagueList: state => state.arr_leagueList,
  arr_selectedLeague: state => state.arr_selectedLeague,
  sortTypes: state => state.sortTypes,
  sportTableLang: state => state.sportTableLang,
  arr_earlyParlayDateList: state => state.arr_earlyParlayDateList,
  int_selectedParlayDate: state => state.int_selectedParlayDate,
  arr_selectedEvent: state => state.arr_selectedEvent,
  allSportLang: state => state.allSportLang,
  allBettypeLang: state => state.allBettypeLang,
  allPlaytypeLang: state => state.allPlaytypeLang,
  oddTypesList: state => state.oddTypesList,
  arr_selectedLeagues: state => state.arr_selectedLeagues,
  arr_leagues: state => state.arr_leagues,
  showCalendarBox: state => state.showCalendarBox,
  selectedMatches: state => state.selectedMatches,
  isParlay: state => state.isParlay,
  isSpecial: state => state.isSpecial,
  isVip: state => state.isVip,
  isPlaceBet: state => state.isPlaceBet,
  isProcessBet: state => state.isProcessBet,
  totalPage: state => state.totalPage,
  selectedPage: state => state.selectedPage,
  s_odd: state => state.s_odd,
  selectedMarket: state => state.selectedMarket,
  isGameBannerSelected: state => state.isGameBannerSelected,
  isCorrectScore: state => state.isCorrectScore,
  parlaySportList: state => state.parlaySportList,
  sportSelected: state => state.sportSelected,
  arr_sportCountMarket: state => state.arr_sportCountMarket,
  isOtr: state => state.isOtr,
  isResult: state => state.isResult,
  arr_earlyEventCountByDate: state => state.arr_earlyEventCountByDate,
  todayRBLeagueList: state => state.todayRBLeagueList,
  arr_filterLeagueList: state => state.arr_filterLeagueList,
  arr_sortedLeagueList: state => state.arr_sortedLeagueList,
  selectedChar: state => state.selectedChar,
  arr_selectedLeagueList: state => state.arr_selectedLeagueList,
  selectedLeagues: state => state.selectedLeagues,
  totalLeagues: state => state.totalLeagues,
  sportList: state => state.sportList,
  reloadSportTable: state => state.reloadSportTable,
  changeOdds: state => state.changeOdds,
  swipe: state => state.swipe,
  isCollapseMatch: state => state.isCollapseMatch,
  showEnd: state => state.showEnd,
  allowLanscape: state => state.allowLanscape,
  showNoScrollEnd: state => state.showNoScrollEnd,
  isHideLeague: state => state.isHideLeague,
  defaultSport: state => state.defaultSport,
  gameBannerId: state => state.gameBannerId,
  gameBannerSportId: state => state.gameBannerSportId,
  schedule_sprt: state => state.schedule_sprt,
  isresult_schedule: state => state.isresult_schedule, 
  filter_select_all: state => state.filter_select_all, 
  market_button_toggle: state => state.market_button_toggle, 
  subMenuStatus: state => state.subMenuStatus,
  sc_cs_hide: state => state.sc_cs_hide,
  selected_date: state => state.selected_date,
  selected_timezone: state => state.selected_timezone,
  selected_league: state => state.selected_league,
  selected_country: state => state.selected_country,
}

// actions
const actions = {
  getSportCCL(context, payload) {
    //EventBus.$emit('enableLoading', true)
    //this.commit('LOADINGSCREEN', window.loading)
    payload = payload ? payload : {}

    var url = window._baseUrl + '/sport-ccl'

    core.$ajax({
      method: 'get',
      url: url,
      data: {
        token: payload.token,
        enableLoading:false,
      },
    }).done(((res)=> {
      var updateCurrCL = this.getters.account
      updateCurrCL.currCL = res.cleft
      this.commit('ACCOUNT', updateCurrCL)
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          com_code: window.compcode,
          acc: JSON.stringify(updateCurrCL),
        },
      }).done((res) => {
        
      })
      $('.balance-wrap').find('.refesh').removeClass('rotate');
      $('.row').find('.refesh').removeClass('refesh2');
      if(res.authtoken) {
        window.authtoken = res.authtoken
        $.ajaxSetup({
          headers: { 'Authorization': `Bearer `+res.authtoken }
        });
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getEventList(context, payload){
    var gameMenuId = 0
    var url = ''
    if(this.getters.account.previewFlag == true){
      url = '/sport-event-list-preview'
    }else{
      url = '/sport-event-list'
    }
    
    if(payload.isGameBanner || this.getters.isSpecial) { //special event(eg: EURO 2020)
      //ajaxData.gameMenuId = this.getters.gameBannerId
      gameMenuId = 1
    }else if(this.getters.isVip && !this.getters.isSpecial){ //vip event
      gameMenuId = 99
    } else if(this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId
    }

    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: {
        schedule: payload.market,
        spread: this.getters.account.spread,          
        gameMenuId: gameMenuId,
        enableLoading:false,
        token: payload.token,
        mode: 1,
      }
    }).done(((res)=> {
      if(res.totalMatch!=null){
        this.commit('SPORT_LIST', res.totalMatch)
      }else{
        this.commit('SPORT_LIST', [])
      }

      if(payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getEventOutright(context, payload){
    var gameMenuId = 0
    var url = ''
    if(this.getters.account.previewFlag == true){
      url = '/sport-event-outright-preview'
    }else{
      url = '/sport-event-outright'
    }
    
    if(payload.isGameBanner || this.getters.isSpecial) { //special event(eg: EURO 2020)
      //ajaxData.gameMenuId = this.getters.gameBannerId
      gameMenuId = 1
    }else if(this.getters.isVip && !this.getters.isSpecial){ //vip event
      gameMenuId = 99
    } else if(this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId
    }

    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: {
        schedule: payload.market,
        spread: this.getters.account.spread,          
        gameMenuId: gameMenuId,
        enableLoading:false,
        token: payload.token,
        mode: 2,
      }
    }).done(((res)=> {
      if(res.totalMatch!=null){
        this.commit('SPORT_LIST', res.totalMatch)

        // check the sport count to select sport
        let current1stSport = Object.keys(res.totalMatch)[0]
        let getSport = _.filter(this.getters.titleSport, function(x){
          return _.includes(x.sid, current1stSport)
        })
  
        this.commit('SELECTED_TEMPLATE',{
          sportId: getSport[0].id
        })
      }else{
        this.commit('SPORT_LIST', [])
      }
      if(payload.callback) {
        return payload.callback(res)
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getLaugueList(context, payload){
    var vue = this
    var date = this.getters.int_selectedParlayDate
    if(this.getters.int_marketToggle == '1' || this.getters.int_marketToggle == '3'){
      date = '0'
    }
    var plytypgrp = '1'
    if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
      date = this.getters.int_selectedParlayDate
      plytypgrp = '5'
    }
    var gameMenuId=0;
    if(this.getters.arr_selectedTemplate.gameMenuId){
      gameMenuId=this.getters.arr_selectedTemplate.gameMenuId ;
    }
    if(payload.isGameBanner || this.getters.isSpecial) { //special event(eg: EURO 2020)
      //ajaxData.gameMenuId = this.getters.gameBannerId
      gameMenuId = 1
    } else if(this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId
    }

    var url = ''
    if(this.getters.account.previewFlag == true){
      url = _baseUrl + '/sport-league-list-preview';
    }else{
      url = _baseUrl + '/sport-league-list';
    }
    
    EventBus.$emit('enableLoading', false)
    this.commit('SUBLOAD', true)

    core.$ajax({
      method: 'get',
      url: url,
      data: {
        sprtid: this.getters.isGameBannerSelected?this.getters.gameBannerSportId:this.getters.arr_selectedTemplate.sportId,
        schedule: this.getters.arr_selectedTemplate.marketKey,
        date: date,
        plytypgrp: plytypgrp,
        langId: window._langid,
        sort: this.getters.selectedSort,
        spread: this.getters.account.spread,          
        gameMenuId: gameMenuId,
        enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
        token: payload.token,
      }
    }).done(((res)=> {
      let stateArr = []
      if(Object.keys(res.leagues).length>0){
        $.each(res.leagues, function(key, val){
          if(!_.includes(stateArr, val.state)){
            stateArr.push(val.state)
          }
        })
        
        this.commit('STATE_LIST', stateArr)
        this.commit('LEAGUELIST', res.leagues)
        this.commit('SUBLOAD', false)
        if(res.earlyParlayDateList){
          this.commit('PARLAYDATELIST', res.earlyParlayDateList)
        }
        this.commit('FILTERLEAGUELIST', [])
        
        if(this.getters.isShowFilter){
          let newLeague = ''

          let newRes = _(res.leagues)
                      .groupBy(o => o.id)
                      .map((g) => _.mergeWith(...g, (o, s, k) => k === 'c' ? o + s : o))
                      .value()

          if(this.getters.int_marketToggle=='1'){
            if(Object.keys(this.getters.todayRBLeagueList).length>0){

              _.forEach(newRes, function(val, key){
                vue.getters.todayRBLeagueList.push(val)
              })
              
              // group by same league 
              newLeague = _(vue.getters.todayRBLeagueList)
                          .groupBy(o => o.id)
                          .map((g) => _.mergeWith(...g, (o, s, k) => k === 'c' ? o + s : o))
                          .value()
                          
              newLeague = _.sortBy(newLeague, function(obj){
                return obj.f
              })
                          
            }else{
              newLeague = _.sortBy(newRes, function(obj){
                return obj.f
              })
            }
          }else{
            newLeague = _.sortBy(newRes, function(obj){
              return obj.f
            })
          }
          this.commit('SORTEDLEAGUELIST', newLeague)
          
          var filterLeagues = _(newLeague)
                              .groupBy(o => o.f.toUpperCase())
                              .map((leg, cap) => ({ cap, leg }))
                              .value();

          this.commit('SELECTED_CHAR', filterLeagues[0].cap)
          this.commit('FILTERLEAGUELIST', filterLeagues)
        }
        
        if(!this.getters.isShowFilter){
          if(this.getters.arr_selectedTemplate.marketKey==3){
            this.dispatch('getLiveSportOdds', {
              loading: 1,
              token: token.arr_2,
              state: (this.getters.selectedState)?this.getters.selectedState:'',
            })
          }else{
            this.dispatch('getSportOdds', {
              loading: 1,
              token: token.arr_2,
              state: (this.getters.selectedState)?this.getters.selectedState:'',
            })
          }
        }
        if(payload && payload.callback) {
          return payload.callback(res)
        }
      }else{
        // when only have rb matches
        if(this.getters.isShowFilter){
          let newLeague = ''
          
          if(this.getters.int_marketToggle=='1'){
            if(Object.keys(this.getters.todayRBLeagueList).length>0){
              newLeague = _.sortBy(vue.getters.todayRBLeagueList, function(obj){
                return obj.f
              })

              this.commit('SORTEDLEAGUELIST', newLeague)

              var filterLeagues = _(newLeague)
                                  .groupBy(o => o.f.toUpperCase())
                                  .map((leg, cap) => ({ cap, leg }))
                                  .value();

              this.commit('SELECTED_CHAR', filterLeagues[0].cap)
              this.commit('FILTERLEAGUELIST', filterLeagues)
            }
          }
        }
        this.commit('REFRESHSCREEN', false)
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getTodayRBLaugueList(context, payload){
    var vue = this
    var date = this.getters.int_selectedParlayDate
    // this.commit('TODAYRBEVENTLIST',[])
    // this.commit('TODAYRBLEAGUELIST',[])
    if(this.getters.int_marketToggle == '1' || this.getters.int_marketToggle == '3'){
      date = '0'
    }
    var plytypgrp = '1'
    if(this.getters.arr_selectedTemplate.subTemplateId == '2'){
      date = this.getters.int_selectedParlayDate
      plytypgrp = '5'
    }
    var gameMenuId=0;
    if(this.getters.arr_selectedTemplate.gameMenuId){
      gameMenuId=this.getters.arr_selectedTemplate.gameMenuId ;
    }
    if(payload.isGameBanner || this.getters.isSpecial) { //special event(eg: EURO 2020)
      //ajaxData.gameMenuId = this.getters.gameBannerId
      gameMenuId = 1
    } else if(this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId
    }

    var url = ''
    if(this.getters.account.previewFlag == true){
      url = _baseUrl + '/sport-league-list-preview';
    }else{
      url = _baseUrl + '/sport-league-list';
    }
    
    EventBus.$emit('enableLoading', false)
    this.commit('SUBLOAD', true)
    
    core.$ajax({
      method: 'get',
      url: url,
      data: {
        sprtid: this.getters.isGameBannerSelected?this.getters.gameBannerSportId:this.getters.arr_selectedTemplate.sportId,
        schedule: 4,
        date: date,
        plytypgrp: plytypgrp,
        langId: window._langid,
        sort: this.getters.selectedSort,
        spread: this.getters.account.spread,          
        gameMenuId: gameMenuId,
        enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
        token: payload.token,
      }
    }).done(((res)=> {
      let stateArr = []
      this.commit('TODAYRBEVENTLIST',[])
      this.commit('TODAYRBLEAGUELIST', {})
      if(Object.keys(res.leagues).length>0){
        this.commit('TODAYRBLEAGUELIST', res.leagues)
        this.commit('SUBLOAD', false)
        
        if(!this.getters.isShowFilter){
          this.dispatch('getTodayRBSportOdds', {
            loading: 1,
            token: token.arr_2,
            state: (this.getters.selectedState)?this.getters.selectedState:'',
          })
        }
        if(payload && payload.callback) {
          return payload.callback(res)
        }
        let newLeague = ''
        if(res.leagues.length>0){
          newLeague = _.sortBy(res.leagues, function(obj){
            return obj.f
          })

          this.commit('SORTEDLEAGUELIST', newLeague)

          var filterLeagues = _(newLeague)
                              .groupBy(o => o.f.toUpperCase())
                              .map((leg, cap) => ({ cap, leg }))
                              .value();

          this.commit('SELECTED_CHAR', filterLeagues[0].cap)
          this.commit('FILTERLEAGUELIST', filterLeagues)
        }
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  selectLeague(context, callback){
    if(callback.leagueid){
      var lgecapt = ''
      if(this.getters.arr_selectedTemplate.subTemplateId == 3){
        lgecapt = callback.capt
      }else{
        lgecapt = callback.lgecapt
      }
      this.commit('SELECTED_LEAGUE', {
        leagueid : callback.leagueid,
        lgecapt: lgecapt,
        c: callback.c
      })
    }
  },
  getSportEventList(context, payload){
    payload = payload ? payload : {}

    var ajaxData = {
      schedule: payload.market ? payload.market : state.selectedMarket,
      spread: this.getters.account.spread,          
      gameMenuId: 0
    }

    if(payload.isGameBanner || this.getters.isSpecial) { //special event(eg: EURO 2020)
      //ajaxData.gameMenuId = this.getters.gameBannerId
      ajaxData.gameMenuId = 1
    } else if(this.getters.isGameBannerSelected) {
      ajaxData.gameMenuId = this.getters.gameBannerId
    }

    ajaxData.token = payload.token

    var url = ''

    if(this.getters.account.previewFlag == true){
      url = '/sport-event-list-preview'
    }else{
      url = '/sport-event-list'
    }

    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData,
    }).done(((res)=> {
      if(!ajaxData.gameMenuId) {
        if(state.selectedMarket == state.market.inPlayMarket.key || payload.market == state.market.inPlayMarket.key){
          this.commit('SPORT_INPLAY_EVENTS', res.totalMatch)
        } else { //is today or early
          this.commit('SPORT_ALL_EVENTS', res.totalMatch)
        }
      }
      if(payload) {
        if(payload.callback)
          return payload.callback(res)
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getSportCount(context, payload){
    var url = ''

    if(this.getters.account.previewFlag == true){
      url = '/sport-count-preview'
    }else{
      url = '/sport-count'
    }
    var ajaxData = {
      enableLoading:false,
    }
    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData,
    }).done(((res)=> {
      this.commit('ALLSPORTCOUNT', res.allCount)
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getSportCountByMarket(context, payload){
    var url = ''
    var ajaxData = {
      enableLoading:false,
    }
    if(this.getters.account.previewFlag == true){
      url = '/sport-count-market-preview'
    }else{
      url = '/sport-count-market'
    }
    
    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData,
    }).done(((res)=> {
      this.commit('SPORTCOUNTMARKET', res.countMarket)
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
  getEarlyEventCountByDate(context, payload){

        var url = ''
        var ajaxData = {
            enableLoading: false,
        }
        if (this.getters.account.previewFlag == true) {
            url = '/event-count-bydate-preview'
        } else {
            url = '/event-count-bydate'
        }

        core.$ajax({
            method: 'get',
            url: window._baseUrl + url,
            data: ajaxData,
        }).done(((res) => {
            this.commit('EARLYCOUNT_BYDATE', res.countByDate)
        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    }
}

// mutations
const mutations = {
  [types.SPORT_LIST] (state, payload ) {
    state.arr_sportList = payload
  },
  [types.ALLSPORTCOUNT] (state, payload ) {
    state.arr_sportAll = payload
  },
  [types.SPORTBETTYPELIST] (state, payload ) {
    state.sportBettypeList = _.keyBy(payload,'sprtId')
  },
  [types.SELECTED_MARKET] (state, payload ) {
    state.int_selectedMarket = payload
  },
  [types.LEAGUELIST] (state, payload ) {
    state.arr_leagueList = payload
  },
  [types.FILTERLEAGUELIST] (state, payload ) {
    state.arr_filterLeagueList = payload
  },
  [types.SORTEDLEAGUELIST] (state, payload) {
    state.arr_sortedLeagueList = payload
  },
  [types.SELECTED_LEAGUE] (state, payload ){
    state.arr_selectedLeague = payload
  },
  [types.PARLAYDATELIST] (state, payload ){
    state.arr_earlyParlayDateList = payload
  },
  [types.SELECTED_PAYLAY_DATE] (state, payload ){
    state.int_selectedParlayDate = payload
  },
  [types.SELECTED_EVENT] (state, payload ){
    state.arr_selectedEvent = payload
  },
  [types.SELECTED_LEAGUES] (state, payload){
    state.arr_selectedLeagues = payload
  },
  [types.ARR_LEAGUES] (state, payload){
    state.arr_leagues = payload
  },
  [types.SHOW_CALENDAR] (state, payload){
    state.showCalendarBox = payload
  },
  [types.SEL_MATCH] (state, payload){
    state.selectedMatches = payload
  },
  [types.IS_PARLAY] (state, payload){
    state.isParlay = payload
  },
  [types.IS_SPECIAL] (state, payload){
    state.isSpecial = payload
  },
  [types.IS_VIP] (state, payload){
    state.isVip = payload
  },
  [types.IS_PLACE_BET] (state, payload){
    state.isPlaceBet = payload
  },
  [types.IS_PROCESS_BET] (state, payload){
    state.isProcessBet = payload
  },
  [types.TOTALPAGE] (state, payload ) {
    state.totalPage = payload
  },
  [types.SELECTED_PAGE] (state, payload ) {
    state.selectedPage = payload
  },
  [types.GAMEBANNER_SELECTED](state, payload){
    state.isGameBannerSelected = payload
  },
  [types.SPORT_ALL_EVENTS] (state, payload ) {
    state.sportAllEvents = payload
  },
  [types.S_ODD] (state, payload ) {
    state.s_odd = payload
  },
  [types.IS_CORRECTSCORE] (state, payload ) {
    state.isCorrectScore = payload
  },
  [types.PARLAY_SPORT_LIST] (state, payload ) {
    state.parlaySportList = payload
  },
  [types.SPORT_SELECTED] (state, payload) {
    state.sportSelected = payload
  },
  [types.SPORTCOUNTMARKET] (state, payload) {
    state.arr_sportCountMarket = payload
  },
  [types.IS_OTR] (state, payload) {
    state.isOtr = payload
  },
  [types.IS_RESULT] (state, payload) {
    state.isResult = payload
  },
  [types.EARLYCOUNT_BYDATE] (state, payload) {
    state.arr_earlyEventCountByDate = payload
  },
  [types.TODAYRBLEAGUELIST] (state,payload) {
    state.todayRBLeagueList = payload
  },
  [types.SELECTED_CHAR] (state, payload) {
    state.selectedChar = payload
  },
  [types.SELECTED_LEAGUELIST] (state, payload ) {
    state.arr_selectedLeagueList = payload
  },
  [types.SELECTEDLEAGUES] (state, payload ) {
    state.selectedLeagues = payload
  },
  [types.TOTALLEAGUES] (state, payload ) {
    state.totalLeagues = payload
  },
  [types.SPORTLIST] (state, payload) {
    state.sportList = payload
  },
  [types.REFRESH_SPORTTABLE] (state, payload){
    state.reloadSportTable = payload
  },
  [types.CHANGE_ODDS] (state, payload ) {
    state.changeOdds = payload
  },
  [types.SWIPE_MODE] (state, payload) {
    state.swipe = payload
  },
  [types.IS_COLLAPSE_MATCH] (state, payload) {
    if (payload == '-1') {
      if(!window.hideLeagues) {
        state.isCollapseMatch = [];
      }
    }
    if(_.isUndefined(state.isCollapseMatch[payload.sport])){
      state.isCollapseMatch[payload.sport]=[];
    }
    if(!_.isUndefined(payload.sport) && !_.isUndefined(payload.lid)) {
      if(payload.lid=='-1'){
        state.isCollapseMatch[payload.sport]=[];
      }else if(_.indexOf(state.isCollapseMatch[payload.sport], payload.lid ) < 0 ) {
        state.isCollapseMatch[payload.sport].push(payload.lid)
      }else{
        state.isCollapseMatch[payload.sport].splice( _.indexOf(state.isCollapseMatch[payload.sport], payload.lid), 1 );
      }
    }
  },
  [types.SHOW_END] (state, payload) {
    state.showEnd = payload
  },
  [types.ALLOW_LANDSACPE] (state, payload) {
    state.allowLanscape = payload
  },
  [types.SHOW_NOSCROLLEND] (state, payload) {
    state.showNoScrollEnd = payload
  },
  [types.IS_HIDE_LEAGUE] (state, payload) {
    if(payload==false){
      if(!window.hideLeagues) {
        state.isHideLeague=[];
      }
    }else if(!_.isUndefined(payload.sport) && !_.isUndefined(payload.status)) {
      state.isHideLeague[payload.sport] = payload.status
    }
  },

  [types.DEFAULT_SPORT] (state, payload) {
    state.defaultSport = payload
  },
  [types.GAME_BANNER_ID](state, payload) {
    state.gameBannerId = payload
  },
  [types.GAME_BANNER_SPORT_ID](state, payload) {
    state.gameBannerSportId = payload
  },
  [types.IS_RESULT_SCHEDULE](state, payload) {
    state.isresult_schedule = payload
  },
  [types.FILTER_SELECT_ALL](state, payload) {
    state.filter_select_all = payload
  },
  SC_CS_HIDE(state, payload){
    state.sc_cs_hide = payload
  },
  
  SCHEDULE_SPORT(state,payload){
    state.schedule_sprt = payload
  },
  MARKET_BUTTON_TOGGLE(state,payload){
    state.market_button_toggle = payload
  },
  SET_SUBMENU_STATUS(state,payload){
    state.subMenuStatus = payload
  },
  SELECTEDDATE(state,payload){
    state.selected_date = payload
  },
  SELECTEDTIMEZONE(state,payload){
    state.selected_timezone = payload
  },
  SELECTEDLEAGUE(state,payload){
    state.selected_league = payload
  },
  SELECTEDCOUNTRY(state,payload){
    state.selected_country = payload
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/sport.js